import { render, staticRenderFns } from "./EllipsisLoader.vue?vue&type=template&id=5e32b726&scoped=true&"
var script = {}
import style0 from "./EllipsisLoader.vue?vue&type=style&index=0&id=5e32b726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e32b726",
  null
  
)

export default component.exports